import React from 'react';
import { useCheckIncludeProfiles } from '@/hooks/useAuthorityLevel';
import Error404 from '@/app/components/Error404';
import WeekChallengeSidebar from './WeekChallengeSidebar';
import WeekChallengeContent from './WeekChallengeContent';
import { Dashboard, DashboardContent } from '@/layouts/dashboard';

export default function CreateWeekChallenge() {
  const isAdmin = !useCheckIncludeProfiles({ only: ['student'] });

  if (!isAdmin) return <Error404 />;

  return (
    <Dashboard>
      <WeekChallengeSidebar />

      <DashboardContent
        viewMode="create"
        className="pt-[72px] md:pt-11"
      >
        <WeekChallengeContent />
      </DashboardContent>
    </Dashboard>
  );
}
